export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/internalcontrol/assets_type/tree',
      method: 'GET'
    }]
  }
}